export default __webpack_public_path__ + "static/media/down-example.e2879660.png";